import { useEffect, useState } from "react";
import styled from "styled-components";

import { AbstractConnector } from "@web3-react/abstract-connector";
import { UnsupportedChainIdError, useWeb3React } from "@web3-react/core";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { WalletLinkConnector } from "@web3-react/walletlink-connector";

import Wallpaper from "../../assets/gg-wallpaper.png";
import CollectionDashboard from "../../components/CollectionDashboard";
import MintDashboard from "../../components/MintDashboard";
import MintPassDashboard from "../../components/MintPassCollectionDashboard";
import { useGnarlyGoatsContractsState } from "../../hooks/useGnarlyGoatsContracts";
import {
  useActiveWeb3React,
  useEagerConnect,
  useInactiveListener
} from "../../hooks/web3";
import {
  Button,
  Interface,
  LandingImage,
  PageWrapper,
  Title
} from "../../theme/components";

export enum Host {
	APP = 'app.gnarlygoats.com',
	PRESALE = 'presale.gnarlygoats.com',
	MINT = 'mint.gnarlygoats.com',
	DEV = 'dev.gnarlygoats.com',
	BASE = 'gnarlygoats.com',
}

const getHost = (): Host => {
	const locationHost = window.location.host
	switch (locationHost.split('.')[0]) {
		case 'app':
			return Host.APP
		case 'presale':
			return Host.PRESALE
		case 'mint':
			return Host.MINT
		case 'dev':
			return Host.DEV
		default:
			return Host.BASE
	}
}

const HomePage = () => {
	const { active } = useActiveWeb3React()

	// handle logic to recognize the connector currently being activated
	const { accountBalance, accountMintPassBalance } =
		useGnarlyGoatsContractsState()

	return (
		<PageWrapper>
			<LandingImage alt={'wallpaper'} src={Wallpaper}></LandingImage>

			{active && (
				<>
					{getHost() === Host.MINT && <MintDashboard />}

					{getHost() === Host.DEV && <MintDashboard />}

					<MintPassDashboard></MintPassDashboard>

					<CollectionDashboard></CollectionDashboard>
				</>
			)}
		</PageWrapper>
	)
}

export default HomePage
